import { Center, CenterProps, Image, Text, VStack } from '@chakra-ui/react';

type Props = CenterProps & {
  icon?: string,
  title: string,
  description: string,
  isTable?: boolean
};

export default function EmptyList({ icon, title, description, isTable = false, ...props }: Props) {
  return (
    <Center
      bg="white"
      py={isTable ? '130px' : 0}
      {...props}
    >
      <VStack 
        spacing="4px" 
        maxW="360px"
        textAlign="center"
      >
        { icon && <Image src={icon} mb="16px" /> }
        <Text 
          as="strong"
          color="#0E121B"
          fontSize="18px"
          fontWeight={500}
          lineHeight="116.667%"
          letterSpacing="-0.198px"
          whiteSpace="break-spaces"
        >
          {title}
        </Text>
        <Text 
          as="span" 
          fontSize="13px"
        >
          {description}
        </Text>
      </VStack>
    </Center>
  )
}
